export default (mainPromise, subPromise) => {
  return mainPromise
    .finally(() => {
      if (subPromise && subPromise.then && subPromise.isPending()) {
        subPromise.cancel();
      }
    });
};



/** WEBPACK FOOTER **
 ** ./app/wip_modules/bluebird-prioritise/index.js
 **/